export default __webpack_public_path__ + "static/media/language change.249a8e83.png";